import { defaultClient as ApolloClient } from "../../../main";
import {
  LEAGUES_ATTITUDE_TO_CLUBS,
  GET_ALL_LEAGUES
} from "../../../graphql/leagues/leaguesQ";
import {
  LEAGUE_MERGE,
  DELETE_LEAGUE,
  LEAGUE_CLUB_REL_MERGE,
  DELETE_LEAGUE_CLUB_REL
} from "../../../graphql/leagues/leaguesM";

export const actions = {
  getAllLeagues: async ({ commit }) => {
    commit("setLoading", true);
    return ApolloClient.query({
      query: GET_ALL_LEAGUES
    })
      .then(({ data }) => {
        commit("setLeagues", data.allLeague.edges);
        commit("setLoading", false);
      })
      .catch(error => {
        console.error(error);
        commit("setLoading", false);
      });
  },
  getLeaguesAttitude: async ({ commit }) => {
    commit("setLoading", true);
    return ApolloClient.query({
      query: LEAGUES_ATTITUDE_TO_CLUBS
    })
      .then(({ data }) => {
        commit("setLeaguesRelationship", data.allLeagueClubRel.edges);
        commit("setLoading", false);
      })
      .catch(error => {
        console.error(error);
        commit("setLoading", false);
      });
  },
  createLeague: ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: LEAGUE_MERGE,
      variables: payload,
      update: (cache, { data: { leagueMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_ALL_LEAGUES
          });

          data.allLeague.edges.push(leagueMerge);

          cache.writeQuery({
            query: GET_ALL_LEAGUES,
            data
          });
        } catch (error) {
          console.error(error);
        }
      }
    })
      .then(() => {
        dispatch("getAllLeagues");
      })
      .catch(error => {
        console.error(error);
      });
  },
  updateLeague: ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: LEAGUE_MERGE,
      variables: payload,
      update: (cache, { data: { leagueMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_ALL_LEAGUES
          });

          const getLeague = data.allLeague.edges.filter(
            el => +el.node.seqno === +payload.seqno
          );
          const leagueIndx = data.allLeague.edges.indexOf(getLeague[0]);
          if (leagueIndx !== -1) {
            data.allLeague.edges[leagueIndx] = leagueMerge;
          } else {
            console.error(
              "Error in updateLeague hook. No index for current leagueMerge"
            );
          }

          cache.writeQuery({
            query: GET_ALL_LEAGUES,
            data
          });
        } catch (error) {
          console.error(error);
        }
      }
    })
      .then(() => {
        dispatch("getAllLeagues");
      })
      .catch(error => {
        console.error(error);
      });
  },
  deleteLeague: ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: DELETE_LEAGUE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_ALL_LEAGUES
          });

          data.allLeague.edges = data.allLeague.edges.filter(
            league => +league.node.seqno !== payload.seqno
          );

          cache.writeQuery({
            query: GET_ALL_LEAGUES,
            data
          });
        } catch (error) {
          console.error(error);
        }
      }
    })
      .then(() => {
        dispatch("getAllLeagues");
      })
      .catch(error => {
        console.error(error);
      });
  },
  /**
   * @param {Int} seqno
   * @param {Int} leagueSeqno
   * @param {Int} club_id
   */
  createRelationshipToLeague: ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: LEAGUE_CLUB_REL_MERGE,
      variables: payload,
      update: (cache, { data: { leagueClubRelMerge } }) => {
        try {
          const data = cache.readQuery({
            query: LEAGUES_ATTITUDE_TO_CLUBS
          });

          data.allLeagueClubRel.edges.push(leagueClubRelMerge);
          cache.writeQuery({
            query: LEAGUES_ATTITUDE_TO_CLUBS,
            data
          });
        } catch (error) {
          console.error(error);
        }
      }
    })
      .then(() => {
        dispatch("getLeaguesAttitude");
      })
      .catch(error => {
        console.error(error);
      });
  },
  /**
   * @param seqno <int>
   * @returns status <string>
   */
  deleteLeagueClubRel: ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: DELETE_LEAGUE_CLUB_REL,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: LEAGUES_ATTITUDE_TO_CLUBS
          });
          data.allLeagueClubRel.edges = data.allLeagueClubRel.edges.filter(
            el => +el.node.seqno !== payload.seqno
          );
          cache.writeQuery({
            query: LEAGUES_ATTITUDE_TO_CLUBS,
            data
          });
        } catch (error) {
          console.error(error);
        }
      }
    })
      .then(() => {
        dispatch("getLeaguesAttitude");
      })
      .catch(error => {
        console.error(error);
      });
  }
};
